import HomeRoute from "../components/routes/HomeRoute";
import messages from "../i18n/messages/en.json";

export default function Page() {
  return <HomeRoute locale="en" messages={messages} />;
}
